import { denormalize, normalize, schema } from 'normalizr';

function tempID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + s4();
}

const filingSchema = new schema.Entity(
  'Filing',
  {},
  {
    idAttribute: (entity, parent) => {
      return entity.DocLink_ID > 0 ? entity.DocLink_ID : tempID();
    }
  }
);

const documentSchema = new schema.Entity(
  'Document',
  {
    Filing: [filingSchema]
  },
  { idAttribute: 'Doc_ID' }
);

const documentGetSchema = new schema.Entity(
  'Transaction',
  {
    Document: documentSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const documentProcessSchema = new schema.Entity(
  'Transaction',
  {
    Document: documentSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    DocumentGet: documentGetSchema,
    DocumentProcess: documentProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    DocumentGet: documentGetSchema,
    DocumentProcess: documentProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

// in root ID:0 = reply from LOAD    ID:1 = transaction being built for PROCESS
export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
